import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  FaFilePdf,
  FaTimes,
  FaDownload
} from "react-icons/fa";
import Breadcrumb from "../components/Breadcrumb";

const Infrastructure = () => {
  const [open, setOpen] =
    useState(false);

  const [docs, setDocs] =
    useState([]);

  const [viewerOpen, setViewerOpen] =
    useState(false);

  const [selectedPdf, setSelectedPdf] =
    useState("");

  const [selectedTitle, setSelectedTitle] =
    useState("");

  useEffect(() => {
    fetch(
      "https://njinternational.ilakshyaerp.in/api/infrastructure-documents"
    )
      .then((res) => res.json())
      .then((data) =>
        setDocs(
          Array.isArray(data)
            ? data
            : []
        )
      )
      .catch(() =>
        setDocs([])
      );
  }, []);

  /* DOWNLOAD */
  const handleDownload = async (
    file,
    title
  ) => {
    const url = `https://njinternational.ilakshyaerp.in/uploads/infrastructure/${file}`;

    const response =
      await fetch(url);

    const blob =
      await response.blob();

    const link =
      document.createElement("a");

    link.href =
      window.URL.createObjectURL(blob);

    link.download =
      title || file;

    document.body.appendChild(
      link
    );

    link.click();
    link.remove();
  };

  /* OPEN PDF */
  const openPdfViewer = (
    file,
    title
  ) => {
    setSelectedPdf(
      `https://njinternational.ilakshyaerp.in/uploads/infrastructure/${file}`
    );

    setSelectedTitle(title);
    setViewerOpen(true);
  };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <div className="about-hero">
        <div className="about-overlay">
          <h1>
            INFRASTRUCTURE
          </h1>

          <p>
            Modern Campus With
            Quality Facilities
          </p>
          <Breadcrumb />
        </div>
      </div>

      <div className="container">

        {/* DOCUMENT TITLE */}
        <h2 className="gallery-title">
          Infrastructure Documents
        </h2>

        {/* PDF GRID */}
        <div className="pdf-grid">

          {docs.length > 0 ? (
            docs.map((d) => (
              <div
                key={d.id}
                className="pdf-card"
              >
                <div
                  className="pdf-card-top"
                  onClick={() =>
                    openPdfViewer(
                      d.file,
                      d.title
                    )
                  }
                >
                  <FaFilePdf className="pdf-icon" />

                  <h3 className="pdf-title">
                    {d.title}
                  </h3>
                </div>

                <button
                  className="pdf-btn"
                  onClick={() =>
                    handleDownload(
                      d.file,
                      d.title
                    )
                  }
                >
                  Download
                </button>
              </div>
            ))
          ) : (
            <div className="life-empty">
              <h3>No Documents</h3>
              <br />
              Files will be uploaded soon.
            </div>
          )}

        </div>

      </div>

      {/* PDF VIEWER */}
      {viewerOpen && (
        <div className="drive-viewer">

          <div className="drive-topbar">

            <div className="drive-left-top">
              <FaFilePdf />
              <span>
                {selectedTitle}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                gap: "15px",
                alignItems:
                  "center",
              }}
            >
              <button
                className="pdf-btn"
                onClick={() =>
                  handleDownload(
                    selectedPdf
                      .split("/")
                      .pop(),
                    selectedTitle
                  )
                }
              >
                <FaDownload />{" "}
                Download
              </button>

              <button
                className="drive-close"
                onClick={() =>
                  setViewerOpen(
                    false
                  )
                }
              >
                <FaTimes />
              </button>

            </div>

          </div>

          <div
            style={{
              flex: 1,
              background:
                "#111",
            }}
          >
            <iframe
              src={selectedPdf}
              title="pdf"
              width="100%"
              height="100%"
              style={{
                border:
                  "none",
              }}
            />
          </div>

        </div>
      )}

      <Footer />
    </>
  );
};

export default Infrastructure;